import { DataBean } from "../DataBean";

export class AuxLiquidationItems extends DataBean {


    public async getAuxLiquidationItemsCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("ProcessContractERP", "java.util.List_getAuxLiquidationItemsCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }
   

    

 
}